import snSessionsService from '../../services/snSessionsService'
import snContentService from '../../services/snContentService.js'
import snUserService from '../../services/snUserService'
import snServicerProfilesService from '../../services/snServicerProfilesService.js'
import _ from 'lodash'
import { query } from '../../services/graphqlService.js'
import snAnalyticsService from '../../services/snAnalyticsService'
import autoLogoutMixin from '~/util/AutoLogoutMixin.js'
import gql from 'graphql-tag'

export default {
  mixins: [autoLogoutMixin],
  computed: {
    isLoggingIn () {
      if (location.pathname.includes('login')) return true
      else return false
    },
    isSearchingForLo () {
      if (location.pathname.includes('lo_not_found')) return true
      else return false
    },
    isSigningUp () {
      if (location.pathname.includes('signup') || location.pathname.includes('onboarding') || location.pathname.includes('go_mobile')) return true
      else return false
    }
  },
  async created () {
    if (!this.isSearchingForLo) {
      if (this.isSigningUp && !this.store.activationCode) {
        await this.getActivationCodeForSignup()
      } else if (this.isLoggingIn && !this.store.activationCode) {
        await this.getActivationCodeForLogin()
      } else {
        await this.getActivationCodeForPageLoad()
      }
    } else {
      this.sn_AutoLogoutMixin_setUpAutoLogout(this.borrowerLogoutUrl)
    }
    const params = new URLSearchParams(document.location.search.substring(1))
    this.store.inMobileApp = params.get('fromMobile') === 'true'
    this.store.inLoPreview = params.get('preview') === 'true'
  },

  methods: {
    borrowerLogoutUrl () {
      return `/borrower/login/${this.store.activationCode || ''}`
    },
    getServicerAndPartnerFromCode (code) {
      const params = `
      query getServicerAndPartnerFromCode ($code: String!) {
        public {
          servicer_activation_code(servicer_activation_code: $code) {
            code
          }
          company(servicer_activation_code: $code){
            terms_of_use_link
            show_company_legal_links
            state_lics
          }
          servicer_profile(servicer_activation_code: $code) {
            id
            active
            name
            last_name
            full_name
            street1
            street2
            city
            state
            license
            state_lics
            profile_url
            unformatted_phone
            office_unformatted_phone
            office_phone
            has_1003_enhanced
            allow_borrower_web_signup
            web_kiosk_enabled
            kiosk_loan_app_redirect_url
            effective_company_logo_url
            effective_company_support_hours
            effective_company_support_phone
            effective_support_email
            effective_company_name
            effective_company_nmls
            effectiveEhLogos {
              id
              typeId
              name
              iconUrl
              iconName
              accountType
              ownerId
              ownerType
            }
            effective_website_disclaimer
            effective_privacy_policy_link
            title
            email
            office_phone
            website
            consumer_access_link
            has_contextual_chat:feature_setting_contextual_chat
            has_contextual_chat_allowed:feature_setting_contextual_chat_allowed
            feature_setting_separate_borrower_tasks_enabled
            feature_setting_use_loan_context_for_borrower
          }
          partner(servicer_activation_code: $code) {
            id
            profile_img_url
            name
            last_name
            full_name
          }
        }
      }
      `
      const variables = {
        code: code
      }
      return query(params, variables)
    },
    async getInformationFromCodeAndSetUpStore (code) {
      try {
        const { data: { content } } = await snContentService.borrowerWebContent(code)
        if (content) this.store.borrowerWebContent = JSON.parse(content)
        const initialDataResponse = await this.getServicerAndPartnerFromCode(code)
        const { data: { public: { company, servicer_activation_code: codeObject, servicer_profile: servicerProfile, partner } } } = initialDataResponse
        this.setUpStore({ company: company, codeObject: codeObject, servicerProfile: servicerProfile, partner: partner })
      } catch (err) {
        console.log(err)
      }
    },
    loadUser () {
      return new Promise(function (resolve, reject) {
        snUserService.show()
          .then((response) => {
            if (response.data.user !== undefined) {
              const currentUser = JSON.parse(response.data.user)
              resolve(currentUser)
            }
          })
          .catch((e) => {
            reject(e)
          })
      }).catch(error => {
        console.log(error)
      })
    },
    async getActivationCodeForSignup () {
      let givenCode = ''
      const pathArray = location.pathname.split('/')
      pathArray.shift()
      if (pathArray[2]) { // e.g. .../signup/asmith1@banknorth.com
        givenCode = pathArray[2]
        this.sn_AutoLogoutMixin_setUpAutoLogout(this.borrowerLogoutUrl)
        this.store.activationCode = givenCode
        this.getInformationFromCodeAndSetUpStore(givenCode)
      } else {
        this.sn_AutoLogoutMixin_setUpAutoLogout(this.borrowerLogoutUrl)
        // Get borrower web content to be able to display logos on login page.
        this.store.support.hours = '7 a.m. - 6 p.m. MT'
        this.store.support.phone = '855.684.2777'
        this.store.support.email = 'support@simplenexus.com'
        const { data: { content } } = await snContentService.borrowerWebContent('')
        if (content) this.store.borrowerWebContent = JSON.parse(content)
      }
    },
    async getActivationCodeForLogin () {
      const pathArray = location.pathname.split('/')
      pathArray.shift()
      if (pathArray[2]) { // e.g. .../login/asmith1@banknorth.com
        const givenCode = pathArray[2]
        this.sn_AutoLogoutMixin_setUpAutoLogout(this.borrowerLogoutUrl)
        this.store.servicerEmail = givenCode
        this.getInformationFromCodeAndSetUpStore(givenCode)
      }
    },
    async getActivationCodeForPageLoad () {
      this.sn_AutoLogoutMixin_setUpAutoLogout(this.borrowerLogoutUrl)
      try {
        let givenCode = ''
        if (this.store.activationCode === null) {
          let servicerCode = null
          try {
            servicerCode = await this.getCurrentUserServicerCode()
            if (servicerCode) givenCode = servicerCode
            this.store.activationCode = givenCode
            const { data: { content } } = await snContentService.borrowerWebContent(givenCode)
            if (content) this.store.borrowerWebContent = JSON.parse(content)
          } catch (err) {
            console.log(err)
          }
          if (!servicerCode) {
            const response = await snSessionsService.getSAC()
            if (response.data.session_sac) {
              const codeObject = JSON.parse(response.data.session_sac)
              givenCode = codeObject.code
              this.store.activationCode = givenCode
            } else if (this.$route.params.code) {
              givenCode = this.$route.params.code
              this.store.activationCode = givenCode
            } else {
              const pathArray = location.pathname.split('/')
              pathArray.shift()
              if (pathArray[2]) { // e.g. .../signup/asmith1@banknorth.com || /login/asmith1@banknorth.com
                givenCode = pathArray[2]
                this.store.activationCode = givenCode
              }
            }
          }
        } else {
          givenCode = this.store.activationCode
        }
        this.getInformationFromCodeAndSetUpStore(givenCode)
      } catch (err) {
        console.log(err)
      }
    },
    async getCurrentUserServicerCode () {
      const currentUser = await this.loadUser()
      return new Promise(resolve => {
        this.$apollo.query({
          query: gql`
          query ($appUserGuid: ID!) {
            app_user (guid: $appUserGuid) {
              id
              servicer_activation_code {
                servicer_profile_id
                code
              }
            }
          }
        `,
          variables: {
            appUserGuid: currentUser.app_user.guid
          }
        }).then(({ data }) => {
          const validCode = data.app_user.servicer_activation_code.code
          resolve(validCode)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getiPhoneMockup ({ partnerId = '', servicerId = '' }) {
      // Currently, graphql expects servicer id as a string type...
      return this.$axios.get(`/servicer_share/iphone_mockup/${servicerId}/${partnerId}`)
    },
    setUpStore ({ company, codeObject, servicerProfile, partner }) {
      if (codeObject && codeObject.code) this.store.activationCode = codeObject.code
      if (servicerProfile) {
        this.store.servicer = _.cloneDeep(servicerProfile)
        this.store.servicer.company = _.cloneDeep(company)
        // The following few lines are returned as JSONs for the time being
        if (this.store.servicer.company.state_lics) this.store.servicer.company.state_lics = JSON.parse(this.store.servicer.company.state_lics)
        if (this.store.servicer.state_lics) this.store.servicer.state_lics = JSON.parse(this.store.servicer.state_lics)
        if (this.store.servicer.state_lics.length === 0 && this.store.servicer.company && this.store.servicer.company.state_lics) this.store.servicer.state_lics = this.store.servicer.company.state_lics
        this.store.support.hours = servicerProfile.effective_company_support_hours
        this.store.support.email = servicerProfile.effective_support_email
        this.store.support.phone = servicerProfile.effective_company_support_phone
        this.store.logoUrl = servicerProfile.effective_company_logo_url
      }
      if (partner) this.store.partner = _.cloneDeep(partner)
      const partnerId = partner ? partner.id : ''
      const servicerId = servicerProfile ? servicerProfile.id : ''
      if (partnerId !== '' || servicerId !== '') {
        this.getiPhoneMockup({ partnerId: partnerId, servicerId: servicerId }).then(({ data: { mockup } }) => {
          if (mockup) this.store.mockup = mockup
        }).catch(
          (error) => {
            console.log(error)
          }
        )
      }
      this.getAdditionalInformationFromApi()
      this.getInternalGoogleAnalytics()
      if (this.store.hasTwoFactorAuthed === undefined || this.store.hasTwoFactorAuthed === null) {
        this.store.hasTwoFactorAuthed = false
      }
    },
    getAdditionalInformationFromApi () {
      snServicerProfilesService.getServicerProfile(this.store.activationCode).then(result => {
        const { data: { links, servicer_link_types: servicerLinkTypes } } = result
        this.store.servicerLinks = links
        this.store.servicerLinkTypes = servicerLinkTypes
      }).catch(error => {
        console.log(error)
      })
    },
    getInternalGoogleAnalytics () {
      snAnalyticsService.getInternalId().then(({ data }) => {
        this.store.internalGoogleAnalyticsId = data.analyticsId
      })
    }
  }
}
